import React from 'react';
import './About.css';

export const Wallets = () => (
  <div className='wallets-wrapper'>
    <Wallet address='0x40126C68BC544D6cfC89D7cDbfC73D0eEd3cB087' img='/wallets/eth.jpg' />
    <Wallet address='bc1qrqp20jzkkz7dgvylhw8zudgf82t90t4ppl2we9' img='/wallets/btc.jpg' />
  </div>
)

interface WalletProps {
  img: string;
  address: string;
}

const Wallet: React.FC<WalletProps> = ({ img, address }) => {
  return (
    <div className='wallet-wrapper'>
      <img loading="lazy" src={img} alt='wallet' />
      <div className='address'>{address}</div>
    </div>
  )
}

interface AboutViewProps {
}

export const AboutView: React.FC<AboutViewProps> = () => {
  return (
    <div className='about-wrapper home-menu'>
      <h1>Project Details</h1>
      <h3>Motivation</h3>
      <span>
        This project arose from the need to keep alive a beloved (and increasingly elusive) edition of Arkham Horror. I wanted a way to share its mysteries with friends scattered thousands of kilometers away. And with the game's sprawling mechanics and expansions often growing beyond human comprehension, I sought to create a system that could track the chaos and guide investigators through a full playthrough.
      </span>
      <h3>Disclaimer</h3>
      <span>
        It was created by a single Arkham Horror fan as a hobby, for fellow fans to enjoy. For the best experience, please use a PC or enable the desktop view in your mobile browser.

        Feedback, suggestions, questions and bug reports are welcome via <a href="mailto:play.arkhamhorror@yahoo.com">play.arkhamhorror@yahoo.com</a>.
      </span>
      <h3>Currently working on</h3>
      <span>Innsmouth Horror expansion, achievements</span>
      <h3>Support</h3>
      <span>It's quite expensive to run the infrastructure for this service. This project relies on contributions from the community in order to cover those costs. Please visit <a href="https://www.patreon.com/cw/PlayArkhamHorrorOnline">my Patreon</a> if you are able to financially support this project, or use the following wallets:</span>

      <Wallets />

      <span>Please note that no features are locked behind a paywall. This project is free to use for everyone and will remain so for as long as it continues to run.</span>

      <h2>Copyright Disclaimer</h2>
      <span>
        The information presented in this app about <a href="https://www.fantasyflightgames.com/en/news/tag/arkham-horror" target='_blank' rel="noopener noreferrer">Arkham Horror™</a>, both textual and graphical, is © <a href="https://www.fantasyflightgames.com/" target='_blank' rel="noopener noreferrer">Fantasy Flight Games</a>. This app is a fan project and is not produced, endorsed, or supported by, or affiliated with Fantasy Flight Games.
 
        All artwork and illustrations are the intellectual property of their respective creators. All Arkham Horror™ images and graphics are copyrighted by Fantasy Flight Games.
      </span>
    </div>
  );
}
